import { Component, OnInit } from '@angular/core';
import { PlaylistService } from '../../services/playlist.service';
import { MessageService } from '../../services/message.service';
import { UtilService } from '../../services/util.service';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { AuthentictionService } from '../../services/authentiction.service';
import { Constant } from '../../services/data';
import * as CryptoJS from 'crypto-js';


@Component({
  selector: 'app-onestream-login',
  templateUrl: './onestream-login.component.html',
  styleUrls: ['./onestream-login.component.css']
})
export class OnestreamLoginComponent implements OnInit{




  playListModal: any = {
    type: 'fromUrl',
    name: '',
    username: '',
    password: '',
    url: '',
    code:'',
    epg:'',
    pin:'',
    confirm_pin:'',
  };
  xcode:boolean=false;
  playList: any = [];
  xstreamList: any;
  isLoading: boolean = false;
  // url_pattern = "([a-z0-9-]+\:\/+)([^\/\s]+)([a-z0-9\-@\^=%&;\/~\+]*)[\?]?([^ \#\r\n]*)#?([^ \#\r\n]*)";
  url_pattern = "([a-z0-9-]+\:\/+)([a-z0-9\-@\^=%&;\/~\+]*)[\?]?([^ \#\r\n]*)#?([^ \#\r\n]*)";
  codeData:any =[];
  code:any;
  urlValue = '';
  platformInfo: string;
  browserInfo:any;
  type='password';

  constructor(private http:HttpClient ,private utilService: UtilService, private playlistService: PlaylistService,private authService:AuthentictionService, private messageService: MessageService, private router: Router){}

  ngOnInit(): void {

  }

  onSubmit(form: NgForm) {

  }

  addPlaylistXstream(form: NgForm) {
    if (form.valid && this.checkDuplicateName(this.playListModal.name)) {
    let passModel = new FormData();
    passModel.append('name', this.playListModal.name);
    passModel.append('url', this.playListModal.url);
    passModel.append('password', this.playListModal.password);
    passModel.append('username', this.playListModal.username);

    this.isLoading = true;
    this.authService.OneStreamLogin(passModel.get('url') as string, passModel).subscribe((res: any) => {
            this.isLoading = false;
            if (res) {
              this.utilService.saveValueStorage(Constant.ONESTREAM, res.auth_token);
              this.utilService.saveValueStorage(Constant.ONEUSERNAME_KEY,this.playListModal.username);
              // this.utilService.saveValueStorage(Constant.ONEPASSWORD_KEY,this.playListModal.password);
              // this.saveEncryptedPassword(this.playListModal.password)
              this.authService.saveEncryptedPassword(this.playListModal.password)
              this.utilService.saveValueStorage(Constant.ONEURL_KEY, this.playListModal.url);
              this.router.navigate(['/home']);
              this.utilService.showErrorSuccess('', "Login Succesfully.");
            }
          }, err => {
            this.isLoading = false;
            this.utilService.showErrorCall("Please enter correct user name or password or url",err);
          });
    }
  }
  saveEncryptedPassword(password: string) {
    const key = 'purple_desktop_app@#$';
    const hash = CryptoJS.AES.encrypt(password, key).toString();
    // const hash = CryptoJS.SHA256(password + key).toString();
    localStorage.setItem('en_p', hash);
  }

 
  

  checkDuplicateName(name) {
    let found = false;
    for (let index = 0; index < this.playList.length; index++) {
      if (this.playList[index].name === name) {
        found = true;
        this.utilService.showErrorToast('', 'Playlist name must be unique');
        break;
      }
    }
    return !found;
  }

  hideShowPassword(){
    if(this.type === 'password'){
      this.type = 'text';
    }
    else{
      this.type='password';
    }
  }
}
